import { ReactElement, useState } from 'react';
import { translate } from 'src/app/project/features/translate/translate';
import BulkEditDialog from './BulkEditDialog';
import PointTags from './PointTags';

type TBulkTagsDialogProps = {
  commonTags: string[];
  options: string[];
  onClose: () => void;
  onSave: (tags: string[]) => Promise<void>;
};

const BulkTagsDialog = ({
  commonTags,
  options,
  onClose,
  onSave,
}: TBulkTagsDialogProps): ReactElement => {
  const [addedTags, setAddedTags] = useState<string[]>([]);

  const handleSave = (): Promise<void> => onSave([...commonTags, ...addedTags]);

  return (
    <BulkEditDialog
      title={translate('add_tags')}
      canSave={addedTags.length > 0}
      onClose={onClose}
      onSave={handleSave}
      body={
        <PointTags
          tags={{ value: addedTags, canEdit: true, onSave: setAddedTags }}
          options={options}
          lockedTags={commonTags}
          isTagLimitedShare={false}
        />
      }
    />
  );
};

export default BulkTagsDialog;
